import { createI18n } from 'vue-i18n';
import en from './locales/en';
import zhCN from './locales/zh-CN';

export type AppLocale = 'en' | 'zh-CN';

// Default to English per spec Section 3.2 P1: '国际化（英文优先）'.
// Persist user choice in localStorage so reloads respect the toggle.
const STORAGE_KEY = 'dumpdeck.locale';

function detectInitialLocale(): AppLocale {
  if (typeof window === 'undefined') return 'en';
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'zh-CN') return saved;
  } catch {
    // localStorage may be unavailable (private mode, etc.) — fall through.
  }
  return 'en';
}

const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    'zh-CN': zhCN,
  },
});

export default i18n;

// Helper used by the LanguageSwitcher to switch locale and persist the choice.
export function setLocale(locale: AppLocale): void {
  i18n.global.locale.value = locale;
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(STORAGE_KEY, locale);
    } catch {
      // Best-effort persistence — not a correctness requirement.
    }
  }
}

export function getLocale(): AppLocale {
  return i18n.global.locale.value as AppLocale;
}
